import { render, staticRenderFns } from "./video-portraitscreen.vue?vue&type=template&id=4443f299&scoped=true&"
import script from "./video-portraitscreen.vue?vue&type=script&lang=js&"
export * from "./video-portraitscreen.vue?vue&type=script&lang=js&"
import style0 from "./video-portraitscreen.vue?vue&type=style&index=0&id=4443f299&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4443f299",
  null
  
)

export default component.exports